import {
  FETCH_CATALOGUE_REQUEST,
  FETCH_CATALOGUE_SUCCESS,
  FETCH_CATALOGUE_FAILURE,
  FETCH_PRODUCT_REQUEST,
  FETCH_PRODUCT_SUCCESS,
  FETCH_PRODUCT_FAILURE,
  SEARCH_PRODUCTS_REQUEST,
  SEARCH_PRODUCTS_SUCCESS,
  SEARCH_PRODUCTS_FAILURE
} from 'actions/ProductActions';

const initialState = {
  isCatalogueFetching: false, // Can remove once we migrate away from this API
  isFetching: false,
  products: [],
  product: null,
  isSearching: false,
  searchProducts: []
};

export default function product(state = initialState, action) {
  switch (action.type) {
    case FETCH_CATALOGUE_REQUEST: {
      return Object.assign({}, state, {
        isCatalogueFetching: true
      });
    }
    case FETCH_CATALOGUE_SUCCESS: {
      return Object.assign({}, state, {
        isCatalogueFetching: false,
        products: action.products
      });
    }
    case FETCH_CATALOGUE_FAILURE: {
      return Object.assign({}, state, {
        isCatalogueFetching: false,
        products: []
      });
    }
    case FETCH_PRODUCT_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      });
    }
    case FETCH_PRODUCT_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        product: action.product
      });
    }
    case FETCH_PRODUCT_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false,
        product: null
      });
    }
    case SEARCH_PRODUCTS_REQUEST: {
      return Object.assign({}, state, {
        isSearching: true
      });
    }
    case SEARCH_PRODUCTS_SUCCESS: {
      return Object.assign({}, state, {
        isSearching: false,
        searchProducts: action.products
      });
    }
    case SEARCH_PRODUCTS_FAILURE: {
      return Object.assign({}, state, {
        isSearching: false
      });
    }
    default:
      return state;
  }
}
